import { actionGenerator } from '../../utils/redux/actionGenerator';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum ENewReviewForm {
  Clear = 'NEW_REVIEW/FORM/CLEAR',
}

export type TNewReviewClear = ITypedReduxAction<ENewReviewForm.Clear>;

export const clearNewReviewFormAction = actionGenerator<ENewReviewForm.Clear>(ENewReviewForm.Clear);

export type TNewReviewFormActions = TNewReviewClear;
